import { render, staticRenderFns } from "./BillFileIndex.vue?vue&type=template&id=4c69d0b6"
import script from "./BillFileIndex.vue?vue&type=script&lang=js"
export * from "./BillFileIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports